export default (fill) => (
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 140.6">
    <path fill="#D0E0E1" d="M0 12.5C0 5.6 5.6 0 12.5 0h53.8l33.4 35 .3 93.1c0 6.9-5.6 12.5-12.5 12.5h-75C5.6 140.6 0 135 0 128.1V12.5z"/>
    <path fill="${fill? fill : '#A1AFAF'}" d="M66.2 0v35h33.4L66.2 0zM28.1 87.5h43.8v6.2H28.1v-6.2zm0 12.5h43.8v6.2H28.1V100zm0 12.5h43.8v6.2H28.1v-6.2z"/>
  </svg>`
)


// WEBPACK FOOTER //
// ./components/Icon/icons/files/all.jsx